class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    getAndShowUpsells();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

var addUpsellProductToCart = function(buttonElement, upsellProductId){
  if(buttonElement.classList.contains("cart-upsells-add-loading")) {
    return;
  }
  buttonElement.classList.toggle("cart-upsells-add-loading");
  let meyerUpsellProduct = {
  'items': [{
    'id': upsellProductId,
    'quantity': 1
  }],
  'sections': 'cart-drawer,cart-icon-bubble',
  'sections_url': window.location.pathname
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(meyerUpsellProduct)
  })
  .then((response) => response.json())
  .then((response) => {
    const parsedState = response;
    document.querySelector('cart-drawer').renderContents(response);
    document.querySelector('cart-drawer').classList.remove("is-empty");
    buttonElement.classList.toggle("cart-upsells-add-loading");
    getAndShowUpsells();
  });
};

var getAndShowUpsells = function(){
  if (document.getElementById('cart-upsells')) {
    document.querySelectorAll('.cart-item').forEach(function(item) {
      let upsell_sku = sessionStorage.getItem('upsell_sku') ? JSON.parse(sessionStorage.getItem('upsell_sku')) : null;
      if(upsell_sku) {
        if(item.dataset.productId === upsell_sku.id) {
          gtag('event', 'upsell_add_to_cart', {'page_title': document.title,'page_location': window.location.href,'id': upsell_sku.id,'name': upsell_sku.name,'price': upsell_sku.price,'sku': upsell_sku.sku});
          sessionStorage.removeItem('upsell_sku');
        }
      }
      fetch('/recommendations/products?product_id=' + item.dataset.productId + '&intent=complementary&section_id=cart-upsells')
        .then(response => response.text())
        .then(data => {
          if (data.includes('cart-upsells-product')) {
            let cartUpsellsDiv = document.getElementById('cart-upsells');
            if (!cartUpsellsDiv.innerHTML.trim()) {
              cartUpsellsDiv.innerHTML = data;
              let cartUpsellProducts = cartUpsellsDiv.getElementsByClassName('cart-upsells-product');
              if(cartUpsellProducts.length > 0) {
                let upsell_sku = {
                  'id': cartUpsellProducts[0].dataset.id,
                  'name': cartUpsellProducts[0].dataset.name,
                  'price': cartUpsellProducts[0].dataset.price,
                  'sku': cartUpsellProducts[0].dataset.sku
                }
                sessionStorage.setItem('upsell_sku', JSON.stringify(upsell_sku))
              } 
            }
          }
        });
    });
  }
};